import AnimationManager from "./AnimationManager";

export default class Pulse {
  public static brightness = AnimationManager.create(
    (element: HTMLElement) => {
      const initialTranform = this.getTransform(element);
      const initialFrame = {
        filter: "brightness(1)",
        transform: `${initialTranform} scale(1)`,
      };
      const endFrame = {
        filter: "brightness(1.5)",
        transform: `${initialTranform} scale(1.01)`,
      };
      return [initialFrame, endFrame, initialFrame];
    },
    {
      duration: 5000,
      easing: "cubic-bezier(0.65, 0, 0.35, 1)",
      iterations: Infinity,
    }
  );

  public static scale = AnimationManager.create(
    (element: HTMLElement) => {
      const initialTranform = this.getTransform(element);
      const initialFrame = {
        transform: `${initialTranform} scale(1)`,
      };
      const endFrame = {
        transform: `${initialTranform} scale(1.2)`,
      };
      return [initialFrame, endFrame, initialFrame];
    },
    {
      easing: "ease-out",
    }
  );

  private static getTransform(element: HTMLElement): string {
    return element.computedStyleMap().get("transform")?.toString() || "";
  }
}
